'use strict';

import * as angular from 'angular';

var services = angular.module('noc.services', ['ngResource']);

services.factory('LoginService', ["$resource", function ($resource) {
    return $resource('rest/user/:action', {},
        {
            authenticate: {
                method: 'POST',
                params: {'action': 'authenticate'}
            },
            authUser: {
                method: 'GET',
                params: {'action': 'authenticateUser', 'authToken': '@authToken'}
            },
            firstlogin: {
                method: 'POST',
                params: {'action': 'firstlogin'}
            }
        }
    );
}]);

services.factory('LogoutService', ["$resource", function ($resource) {
    function LogoutService() {
    }

    LogoutService.prototype.logout = function () {
        return $resource('rest/logout/:id');
    };

    return new LogoutService();
}]);

services.factory('ContentStatisticsResourceService', ["$resource", function ($resource) {
    function ContentStatisticsResourceService() {
    }

    ContentStatisticsResourceService.prototype.report = function () {
        return $resource('rest/contentstatistics/:action', {},
            {
                getSynopsis: {
                    method: 'GET', isArray: false,
                    params: {'action': 'synopsis', 'projectId': '@projectId', 'from': '@from', 'to': '@to'}
                },
                getUserLoyalty: {
                    method: 'GET', isArray: true,
                    params: {'action': 'userloyalty', 'projectId': '@projectId', 'from': '@from', 'to': '@to'}
                },
                getContentVisits: {
                    method: 'GET', isArray: true,
                    params: {'action': 'contentvisits', 'projectId': '@projectId', 'from': '@from', 'to': '@to'}
                },
                getSessionVisits: {
                    method: 'GET', isArray: true,
                    params: {'action': 'sessionVisits', 'projectId': '@projectId', 'from': '@from', 'to': '@to'}
                },
                getDevicesDist: {
                    method: 'GET', isArray: true,
                    params: {'action': 'devices', 'projectId': '@projectId', 'from': '@from', 'to': '@to'}
                },
                getBrowserDist: {
                    method: 'GET', isArray: true,
                    params: {'action': 'browsers', 'projectId': '@projectId', 'from': '@from', 'to': '@to'}
                },
                getScreenSize: {
                    method: 'GET', isArray: true,
                    params: {'action': 'screen', 'projectId': '@projectId', 'from': '@from', 'to': '@to'}
                }
            });
    };
    return new ContentStatisticsResourceService();
}]);


services.factory('AuthenticateService', ["$resource", function ($resource) {
    this.authenticateResource = $resource('rest/user/auth');
    
    function AuthenticateService() {
    }
    
    AuthenticateService.prototype.authenticateUser = function (authToken, callback) {
        return this.authenticateResource.get({authToken: '@authToken'}, callback);
    };
}]);

services.factory('MaintenanceBoxResource', ["$resource", function ($resource) {
    return $resource('rest/maintenance/project/:projectId', {
        projectId: '@projectId'
    });
}]);

services.factory('TrainDataService', ["$resource", function ($resource) {
    return $resource('rest/traindata/:id', {
        id: '@id',
        projectId: '@projectId'
    });
}]);

services.factory('TrainGeoService', ["$resource", function ($resource) {
    return $resource('rest/traingeo/:id', {
        id: '@id',
        projectId: '@projectId'
    });
}]);

services.factory('TrainService', ["$resource", function ($resource) {

    function TrainService() {
        this.TrainConnectivityResource = $resource('rest/trainconnectivity');
        this.TrainConnectivitiesResource = $resource('rest/trainconnectivities');

    }

    TrainService.prototype.getTrains = function () {
        return $resource('rest/train/project/:projectId', {
            projectId: '@projectId'
        });
    };

    TrainService.prototype.getTrain = function (callback) {
        return $resource('rest/train/:trainId', {
            trainId: '@trainId'
        }, callback);
    };

    TrainService.prototype.getTrainData = function () {
        return $resource('rest/traindata');
    };

    TrainService.prototype.getConnectivityData = function (projectId, trainId, date, callback) {
        return this.TrainConnectivityResource.get({
            projectId: projectId,
            trainId: trainId,
            date: date
        }, callback);
    };

    TrainService.prototype.getConnectivityDataByDay = function (projectId, date, callback, errorCallback) {
        return this.TrainConnectivitiesResource.query({
            projectId: projectId,
            date: date
        }, callback, errorCallback)
    };

    TrainService.prototype.getConnectivityDataById = function () {
        return $resource('rest/traincon/:id', {
            id: '@id'
        });
    };

    TrainService.prototype.getRemarkById = function () {
        return $resource('rest/trainremark/:id', {
            id: '@id'
        });
    };

    TrainService.prototype.getRemarksByDate = function (projectId, date) {
        return $resource('rest/trainremarks/date/:projectId', {
            projectId: projectId, date: date
        });
    };

    TrainService.prototype.getNewRemark = function () {
        return $resource('rest/newtrainremark/:projectId', {
            projectId: '@projectId'
        });
    };

    TrainService.prototype.getConfig = function (projectId, trainId) {
        return $resource('rest/trainconfig/:trainId', {projectId: projectId, trainId: trainId});
    };

    TrainService.prototype.addTrain = function () {
        return $resource('rest/trainconfig/new');
    };

    TrainService.prototype.deleteTrain = function (projectId, trainId) {
        return $resource('rest/trainconfig/:trainId', {trainId: trainId}, {
            delete: {
                method: 'DELETE',
                params: {projectId: projectId}
            }
        });
    };

    TrainService.prototype.getTrainTypes = function () {
        return $resource('rest/trainconfig/traintypes');
    };

    TrainService.prototype.getTypeConfiguration = function (projectId, trainId) {
        return $resource('rest/project/:projectId/trains/:trainId/configuration', {projectId: projectId, trainId: trainId});
    };

    return new TrainService();

}]);

services.factory('RemoteControlResourceService', ["$resource", function ($resource) {

    function RemoteControlResourceService() {
        this.config = $resource('rest/remotecontrol');
    }

    RemoteControlResourceService.prototype.getById = function (projectId, messageId, callback) {
        return this.config.query({
                projectId: projectId,
                id: messageId
            },
            callback);
    };

    RemoteControlResourceService.prototype.remotecontrol = function () {
        return this.config;
    };

    return new RemoteControlResourceService();
}]);

services.factory('ProjectResourceService', ["$resource", function ($resource) {

    function ProjectResourceService() {
        this.config = $resource('rest/config/project/:projectId');
    }

    ProjectResourceService.prototype.getAllProjects = function () {
        return $resource('rest/project/:id', {
            id: '@id'
        });
    };

    ProjectResourceService.prototype.getConfig = function (projectId) {
        return this.config.get({projectId: projectId});
    };

    return new ProjectResourceService();
}]);


services.factory('UserService', ["$resource", function ($resource) {
    return $resource('rest/user/:id', {
        id: '@id'
    });
}]);
services.factory('UserResourceService', ["$resource", function ($resource) {
    function UserResourceService() {

    }

    UserResourceService.prototype.user = function (id) {
        return $resource('rest/user/:id', {id: id});
    };

    UserResourceService.prototype.usercomposite = function (projectId) {
        return $resource('rest/usercomposites').query({projectId: projectId});
    };
    UserResourceService.prototype.userManagementComposite = function () {
        return $resource('rest/usermanagementComposite/:id', {id: '@id'});
    };

    UserResourceService.prototype.userManagementComposites = function () {
        return $resource('rest/usermanagementComposite');
    };

    UserResourceService.prototype.resetPassword = function () {
        return $resource('rest/resetpassword/:userId', {userId: '@userId'});
    };
    UserResourceService.prototype.resetPasswordByEmail = function () {
        return $resource('rest/reset');
    };
    return new UserResourceService();
}]);

services.factory('NmsConfigResourceService', ["$resource", function ($resource) {

        function NmsConfigResourceService() {
        }

        NmsConfigResourceService.prototype.requestConfig = function (projectId) {
            return $resource('rest/config/noc/:action/:projectid', {},
                {
                    getComplete: {
                        method: 'GET', isArray: false,
                        params: {'action': 'all', 'projectid': projectId}
                    },
                    getSqis: {
                        method: 'GET', isArray: true,
                        params: {'action': 'sqi', 'projectid': projectId}
                    },
                    getComponents: {
                        method: 'GET', isArray: true,
                        params: {'action': 'components', 'projectid': projectId}
                    }

                }
            );
        };


        return new NmsConfigResourceService();
    }]
);

services.factory('ReferenceAreaService', ["$resource", "$http", function ($resource,$http) {
    function ReferenceAreaService() {
    }

    ReferenceAreaService.prototype.waypoint = function () {
        return $resource('rest/waypoint');
    };
    ReferenceAreaService.prototype.waypoints = function () {
        return $resource('rest/waypoints');
    };
    ReferenceAreaService.prototype.customReferenceAreas = function () {
        return $resource('rest/customreferencearea');
    };
    ReferenceAreaService.prototype.customReferenceArea = function () {
        return $resource('rest/customreferencearea/:id');
    };
    ReferenceAreaService.prototype.depots = function () {
        return $resource('rest/depots');
    };
    ReferenceAreaService.prototype.uploadReferenceAreas = function (projectId, fileFormData) {
        return $http.post('rest/referenceAreasCSV', fileFormData, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined},
            params: { projectId : projectId }
        });
    }
    return new ReferenceAreaService();
}]);

services.factory('DashboardService', ["$resource", function ($resource) {
    function DashboardService() {
        this.gridResource = $resource('rest/dashboard/fleet/project/:projectId/grid');
        this.consumptionResource = $resource('rest/dashboard/fleet/project/:projectId/consumption');
        this.contentResource = $resource('rest/dashboard/fleet/project/:projectId/content');
    }

    DashboardService.prototype.getTrainLogins = function (project, train, tz, callback) {
        return $resource('rest/dashboard/train/:trainId/project/:projectId/logins').query({
            'projectId': project,
            'trainId': train,
            'timezone': tz
        }, callback);
    };

    DashboardService.prototype.getTrainConsumption = function (project, train, tz, callback) {
        return $resource('rest/dashboard/train/:trainId/project/:projectId/consumption').get({
            'projectId': project,
            'trainId': train,
            'timezone': tz
        }, callback);
    };

    DashboardService.prototype.getTrainSqis = function (project, train, tz, callback) {
        return $resource('rest/dashboard/train/:trainId/project/:projectId/sqis').query({
            'projectId': project,
            'trainId': train,
            'timezone': tz
        }, callback);
    };

    DashboardService.prototype.getTrainVung = function (project, train, tz, callback) {
        return $resource('rest/dashboard/train/:trainId/project/:projectId/vung').query({
            'projectId': project,
            'trainId': train,
            'timezone': tz
        }, callback);
    };

    DashboardService.prototype.getTrainContent = function (project, train, callback) {
        return $resource('rest/dashboard/train/:trainId/project/:projectId/content').query({
            'projectId': project,
            'trainId': train
        }, callback);
    };

    DashboardService.prototype.getTrainNtvDashboard = function (project, train, callback) {
        return $resource('rest/dashboard/train/:trainId/project/:projectId/consumption').query({
            'projectId': project,
            'trainId': train
        }, callback);
    };

    DashboardService.prototype.getTrainAvgConsumed = function (project, train, tz, callback) {
        return $resource('rest/dashboard/train/:trainId/project/:projectId/avgconsumed').query({
            'projectId': project,
            'trainId': train,
            'timezone': tz
        }, callback);
    };

    DashboardService.prototype.getNtvTrainGrid = function (project, callback) {
        return this.gridResource.query({
            projectId: project
        }, callback);
    };

    DashboardService.prototype.getFleetNtvPortalConsumption = function (project, tz, callback) {
        return this.consumptionResource.get({
            'projectId': project,
            'timezone': tz
        }, callback);
    };

    DashboardService.prototype.getFleetNtvPortalContent = function (project, callback) {
        return this.contentResource.query({
            'projectId': project
        }, callback);
    };

    DashboardService.prototype.getFleetTotalLogins = function (project, tz, callback) {
        return $resource('rest/dashboard/fleet/project/:projectId/logins').query({
            'projectId': project,
            'timezone': tz
        }, callback);
    };

    DashboardService.prototype.getFleetConsumptionAverages = function (project, tz, callback) {
        return $resource('rest/dashboard/fleet/project/:projectId/avgconsumed').query({
            'projectId': project,
            'timezone': tz
        }, callback);
    };

    DashboardService.prototype.getFleetVuNgAverages = function (project, tz, callback) {
        return $resource('rest/dashboard/fleet/project/:projectId/vung').query({
            'projectId': project,
            'timezone': tz
        }, callback);
    };

    DashboardService.prototype.getFleetSqiAverages = function (project, tz, callback) {
        return $resource('rest/dashboard/fleet/project/:projectId/sqi').query({
            'projectId': project,
            'timezone': tz
        }, callback);
    };

    return new DashboardService();
}]);

services.factory('TripService', ["$resource", "$state", function ($resource, $state) {

    function TripService() {
        this.tripResource = $resource('rest/trip/:projectId/:tripId');
        this.tripsResource = $resource('rest/trips');
        this.periodTripResource = $resource('rest/train/period');
        this.periodPercentileResource = $resource('rest/trips/percentile');
        this.projectTripsTrendResource = $resource('rest/trip/trend');
        this.fleetSqiResource = $resource('rest/trip/sqis/fleet');
        this.trainSqiResource = $resource('rest/trip/sqis/train');
    }

    TripService.prototype.getPeriodData = function (start, end, project, trainId, callback) {
        return this.periodTripResource.get({
            projectId: project,
            relativeId: trainId,
            from: start,
            to: end
        }, callback, (error) => {
            $state.go('period.search', {
                projectId: project
            })
        });
    };

    TripService.prototype.getTrips = function (start, end, project, trainIds, mainTrips, callback) {
        return this.tripsResource.query({
            projectId: project,
            trainIds: trainIds,
            from: start,
            to: end,
            main: mainTrips
        }, callback);
    };

    TripService.prototype.getFleetSqis = function (criteria, callback) {
        return this.fleetSqiResource.query(criteria, callback);
    };

    TripService.prototype.getTrainSqis = function (criteria, callback) {
        return this.trainSqiResource.query(criteria, callback);
    };

    TripService.prototype.getTripById = function (project, tripId, callback) {
        return this.tripResource.get({
            projectId: project,
            tripId: tripId
        }, callback, (error) => {
            $state.go('trip.search', {
                projectId: project
            })
        });
    };

    TripService.prototype.getTripTrend = function (start, end, project, callback) {
        return this.projectTripsTrendResource.query({
            from: start,
            to: end,
            projectId: project
        }, callback);
    };
    return new TripService();
}]);

services.factory('CsvService', ["$resource", function ($resource) {
    function CsvService() {
        this.kmlResource = $resource('rest/csv/period');
    }

    CsvService.prototype.getMessages = function (criteria, callback) {
        return this.kmlResource.get(criteria, callback);
    };
    return new CsvService();
}]);

services.factory('ChartService', ["$resource", function ($resource) {

    function ChartService() {
    }

    ChartService.prototype.getPingMessages = function (criteria, callback) {
        return $resource('rest/ping').query(criteria, callback);
    };

    ChartService.prototype.getTrainUserMessages = function (criteria, callback) {
        return $resource('rest/trainuser').query(criteria, callback);
    };

    ChartService.prototype.getCombinedTrainUserMessages = function (criteria, callback) {
        return $resource('rest/trainuser/combined').query(criteria, callback);
    };

    ChartService.prototype.getCapacityTestData = function (criteria, callback) {
        return $resource('rest/mar3/capacitytest').query(criteria, callback);
    };

    ChartService.prototype.getMar3LinkStatisticsMessages = function (criteria, callback) {
        return $resource('rest/mar3/linkstatistic').query(criteria, callback);
    };

    ChartService.prototype.getMar3CongestionMessages = function (criteria, callback) {
        return $resource('rest/mar3/congestion').query(criteria, callback);
    };

    ChartService.prototype.getMar3LteStatisticsMessages = function (criteria, callback) {
        return $resource('rest/mar3/ltestatistic').query(criteria, callback);
    };

    ChartService.prototype.getMar3GsmStatisticsMessages = function (criteria, callback) {
        return $resource('rest/mar3/gsmstatistic').query(criteria, callback);
    };

    ChartService.prototype.getMar3WcdmaStatisticsMessages = function (criteria, callback) {
        return $resource('rest/mar3/wcdmastatistic').query(criteria, callback);
    };

    ChartService.prototype.getMar3LinkSessionsMessages = function (criteria, callback) {
        return $resource('rest/mar3/linksession').query(criteria, callback);
    };

    ChartService.prototype.getMar3CombinedLinkStatisticsMessages = function (criteria, callback) {
        return $resource('rest/mar3/link/combined').query(criteria, callback);
    };

    ChartService.prototype.getObisDeviceTemperatureMessages = function (criteria, callback) {
        return $resource('rest/obis/temperature').query(criteria, callback);
    };

    ChartService.prototype.getObisDeviceLifeSignMessages = function (criteria, callback) {
        return $resource('rest/obis/lifesign').query(criteria, callback);
    };

    ChartService.prototype.getObisDeviceLoopStatusMessages = function (criteria, callback) {
        return $resource('rest/obis/loopstatus').query(criteria, callback);
    };

    ChartService.prototype.getObisDevicePSUDetailsMessages = function (criteria, callback) {
        return $resource('rest/obis/psudetails').query(criteria, callback);
    };


    ChartService.prototype.getObisDevicePSUDetailsSummaryMessages = function (criteria, callback) {
        return $resource('rest/obis/psudetailssummary').query(criteria, callback);
    };

    ChartService.prototype.getObisDeviceSWPlatformStatusMessages = function (criteria, callback) {
        return $resource('rest/obis/swplatformstatus').query(criteria, callback);
    };

    ChartService.prototype.getObisDeviceAssignedJourneyMessages = function (criteria, callback) {
        return $resource('rest/obis/assignedjourney').query(criteria, callback);
    };

    ChartService.prototype.getObisDeviceDegradedMessages = function (criteria, callback) {
        return $resource('rest/obis/degraded').query(criteria, callback);
    };

    ChartService.prototype.getObisMtsDownloadStatusMessages = function (criteria, callback) {
        return $resource('rest/obis/mtsdownloadstatus').query(criteria, callback);
    };

    ChartService.prototype.getObisLineMessages = function (criteria, callback) {
        return $resource('rest/obis/line').query(criteria, callback);
    };

    ChartService.prototype.getObisDeviceOperationHoursMessages = function (criteria, callback) {
        return $resource('rest/obis/operationhours').query(criteria, callback);
    };

    ChartService.prototype.getObisTrainPositionMessages = function (criteria, callback) {
        return $resource('rest/obis/trainposition').query(criteria, callback);
    };

    ChartService.prototype.getObisMmdBacklightMessages = function (criteria, callback) {
        return $resource('rest/obis/mmdbacklight').query(criteria, callback);
    };

    ChartService.prototype.getCombinedPortalConsumption = function (criteria, callback) {
        return $resource('rest/portal/consumption/combined').query(criteria, callback);
    };

    ChartService.prototype.getVirtualUserMessages = function (criteria, callback) {
        return $resource('rest/vu').query(criteria, callback);
    };

    ChartService.prototype.getGpsPositionData = function (criteria, callback) {
        return $resource('rest/positionDataComposite').query(criteria, callback);
    };

    ChartService.prototype.getCombinedMar3LinkSession = function (criteria, callback) {
        return $resource('rest/mar3/linksession/combined').query(criteria, callback);
    };

    ChartService.prototype.getRadioUserCount = function (criteria, callback) {
        return $resource('rest/radioUserCount').query(criteria, callback);
    };

    ChartService.prototype.template = function () {
        return $resource('rest/chart/template/:id');
    };

    ChartService.prototype.templates = function () {
        return $resource('rest/chart/template');
    };

    ChartService.prototype.templatesForUser = function () {
        return $resource('rest/chart/template/:userId');
    };

    return new ChartService();
}]);

services.factory('SimService', ["$resource", function ($resource) {
    function SimService() {

    }

    SimService.prototype.getSimConfigurations = function (criteria, callback) {
        return $resource('rest/config/mar3/sim').query(criteria, callback);
    };
    SimService.prototype.getSimStatistics = function (criteria, callback) {
        return $resource('rest/mar3/simstatistics').query(criteria, callback);
    };
    SimService.prototype.getSimMetadata = function (criteria, callback) {
        return $resource('rest/config/mar3/simmetadata').get(criteria, callback);
    };

    SimService.prototype.getAllSimConfigurations = function (criteria, callback) {
        return $resource('rest/config/mar3/sims').query(criteria, callback);
    };
    SimService.prototype.getSimConfigurationWithId = function (id, criteria, callback) {
        return $resource('rest/config/mar3/sims/:id', {id: id}).get(criteria, callback);
    };

    SimService.prototype.getResourceForNewSim = function (resourceObject) {
        return $resource('rest/config/mar3/sims', {},
            {
                store: {
                    method: 'POST',
                    params: {projectId: resourceObject.projectId}
                }
            });

    };
    SimService.prototype.getResourceForSimWithId = function (resourceObject) {
        return $resource('rest/config/mar3/sims/:id', {id: resourceObject.id},
            {
                delete: {
                    method: 'DELETE',
                    params: {projectId: resourceObject.projectId}
                },
                store: {
                    method: 'POST',
                    params: {projectId: resourceObject.projectId}
                }
            });

    };
    return new SimService();
}]);

services.factory('ZabbixResourceService', ["$resource", function ($resource) {
    function ZabbixResourceService() {

    }

    ZabbixResourceService.prototype.trainStructure = function () {
        return $resource('rest/zabbix/structure');
    };

    ZabbixResourceService.prototype.structure = function () {
        return $resource('rest/zabbix/structure/:trainId');
    };

    ZabbixResourceService.prototype.customConfig = function () {
        return $resource('rest/zabbix/custom/config/:trainId');
    };

    ZabbixResourceService.prototype.getTrainMappings = function (projectId, callback) {
        return $resource('rest/zabbix/trainmappings', {projectId: projectId}).query(callback);
    };

    ZabbixResourceService.prototype.getZabbixToken = function (query, callback) {
        return $resource('rest/zabbix/token', query).get();
    };

    ZabbixResourceService.prototype.postTrainMapping = function (projectId) {
        return $resource('rest/zabbix/trainmappings', {},
            {
                store: {
                    method: 'POST',
                    params: {projectId: projectId}
                }
            });
    };

    ZabbixResourceService.prototype.getJiraMapping = function (projectId, eventId, callback) {
        return $resource('rest/zabbix/jiramappings/:eventId', {
            projectId: projectId,
            eventId: eventId
        }).get(callback);
    };
    ZabbixResourceService.prototype.postJiraMapping = function (projectId) {
        return $resource('rest/zabbix/jiramappings/', {},
            {
                store: {
                    method: 'POST',
                    params: {projectId: projectId}
                }
            });
    };
    ZabbixResourceService.prototype.updateJiraMapping = function (projectId, eventId) {
        return $resource('rest/zabbix/jiramappings/:eventId', {},
            {
                store: {
                    method: 'POST',
                    params: {projectId: projectId, eventId: eventId}
                },
                delete: {
                    method: 'DELETE',
                    params: {projectId: projectId, eventId: eventId}
                }
            });
    };

    ZabbixResourceService.prototype.trainMapping = function () {
        return $resource('rest/zabbix/trainmappings/:id');
    };

    ZabbixResourceService.prototype.acknowledge = function () {
        return $resource('rest/zabbix/acknowledge/:trainId');
    };

    ZabbixResourceService.prototype.assignIncident = function () {
        return $resource('rest/zabbix/incident/:trainId');
    };

    return new ZabbixResourceService();
}]);

services.factory('PuppetResourceService', ["$resource", function ($resource) {
    function PuppetResourceService() {

    }

    PuppetResourceService.prototype.configByTrainId = function () {
        return $resource('rest/puppet/configByTrainId');
    };

    return new PuppetResourceService();
}]);

services.factory('TrainConsistResourceService', ["$resource", function ($resource) {
    function PuppetResourceService() {

    }

    PuppetResourceService.prototype.configByTrainId = function () {
        return $resource('rest/puppet/configByTrainId');
    };

    return new PuppetResourceService();
}]);

services.factory('SchedulingResourceService', ["$resource", function ($resource) {
    function SchedulingResourceService() {
    }
    SchedulingResourceService.prototype.preparedReportByDate = function () {
        return $resource('rest/scheduling/preparedreport');
    };

    return new SchedulingResourceService();
}]);

services.factory('SynchronizationResourceService', ["$resource", function ($resource) {
    function SynchronizationResourceService() {
    }
    SynchronizationResourceService.prototype.getSyncEntityData = function () {
        return $resource('rest/portal/sync/train/overview');
    };
    return new SynchronizationResourceService();
}]);

services.factory('IncidentService', ["$resource", function ($resource) {
    function IncidentService() {

    }

    IncidentService.prototype.raiseRfIncident = function () {
        return $resource('rest/incidents/raiserfincident');
    };

    IncidentService.prototype.getIncidents = function () {
        return $resource('rest/incidents/getincidents');
    };

    IncidentService.prototype.getTrainIncidents = function () {
        return $resource('rest/incidents/gettrainincidents');
    };

    IncidentService.prototype.getRfAttributes = function () {
        return $resource('rest/incidents/getrfassets');
    };

    return new IncidentService();
}]);
services.factory('TrainScheduleResourceService', ["$resource", function ($resource) {
    function TrainScheduleResourceService() {
    }

    TrainScheduleResourceService.prototype.timetable = function () {
        return $resource('rest/trainschedule/timetable');
    };
    TrainScheduleResourceService.prototype.timetableEntry = function () {
        return $resource('rest/trainschedule/timetableentry');
    };
    TrainScheduleResourceService.prototype.scheduleEntries = function () {
        return $resource('rest/trainschedule/entry');
    };
    TrainScheduleResourceService.prototype.scheduleEntry = function () {
        return $resource('rest/trainschedule/entry/:id');
    };
    TrainScheduleResourceService.prototype.planning = function () {
        return $resource('rest/trainschedule/date');
    };
    TrainScheduleResourceService.prototype.currentSchedule = function () {
        return $resource('rest/trainschedule/current');
    };
    return new TrainScheduleResourceService();
}]);

services.factory('ExportResourceService', ["$resource", function ($resource) {
    function ExportResourceService() {
    }

    ExportResourceService.prototype.exportTrips = function () {
        return $resource('rest/export/dashboard/trips');
    };

    return new ExportResourceService();
}]);

services.factory('AdvancedQueryResourceService', ["$resource", function ($resource) {
    function AdvancedQueryResourceService() {
    }

    AdvancedQueryResourceService.prototype.trips = function () {
        return $resource('rest/advanced/trips');
    };
    AdvancedQueryResourceService.prototype.recalculateTrips = function () {
        return $resource('rest/recalculate/trips');
    };
    AdvancedQueryResourceService.prototype.recalculateTripsByTrainIds = function () {
        return $resource('rest/recalculate/tripsByTrainIds');
    };
    AdvancedQueryResourceService.prototype.calculateTripsBySchedule = function () {
        return $resource('rest/calculate/tripsBySchedule');
    };
    AdvancedQueryResourceService.prototype.fetchTrainSchedule = function () {
        return $resource('rest/fetch/trainSchedule');
    };
    AdvancedQueryResourceService.prototype.tripsDashboard = function () {
        return $resource('rest/advanced/trips/dashboard/ids');
    };
    AdvancedQueryResourceService.prototype.waypoints = function () {
        return $resource('rest/advanced/waypoints');
    };
    AdvancedQueryResourceService.prototype.SQIs = function () {
        return $resource('rest/advanced/sqis');
    };
    AdvancedQueryResourceService.prototype.services = function () {
        return $resource('rest/advanced/services');
    };
    AdvancedQueryResourceService.prototype.filter = function () {
        return $resource('rest/advanced/filter/:id');
    };
    AdvancedQueryResourceService.prototype.filters = function () {
        return $resource('rest/advanced/filter');
    };

    AdvancedQueryResourceService.prototype.favorite = function () {
        return $resource('rest/advanced/filter/favorite/:id');
    };
    AdvancedQueryResourceService.prototype.favorites = function () {
        return $resource('rest/advanced/filter/favorite');
    };
    AdvancedQueryResourceService.prototype.favoriteForUser = function () {
        return $resource('rest/advanced/filter/favorite/:userId');
    };

    return new AdvancedQueryResourceService();
}]);

services.factory('ConfigurationResourceService', ["$resource", "$state", function ($resource, $state) {
    function ConfigurationResourceService() {
    }

    ConfigurationResourceService.prototype.noc = function () {
        return $resource('rest/config/noc/all/:projectId', {}, {
            get: {
                method: 'GET',
                isArray: false,
                transformResponse: function (data, header, status, config, statusText) {
                    var response: any = {};
                    response.data = data ? JSON.parse(data) : {};
                    response.status = status;
                    response.config = config;
                    response.statusText = statusText;
                    return response;
                }
            }
        });
    };

    ConfigurationResourceService.prototype.nocTrainTypes = function () {
        return $resource('rest/config/noc/all/:projectId/traintypes', {}, {
            get: {
                method: 'GET',
                isArray: false,
                transformResponse: function (data, header, status, config, statusText) {
                    var response: any = {};
                    response.data = JSON.parse(data);
                    response.status = status;
                    response.config = config;
                    response.statusText = statusText;
                    return response;
                }
            }
        });
    };

    ConfigurationResourceService.prototype.nocTrainTypeConfig = function (projectId, trainTypeId) {
        return $resource('rest/config/noc/all/'+projectId+'/traintypes/'+trainTypeId, {}, {
            get: {
                method: 'GET',
                isArray: false,
                transformResponse: function (data, header, status, config, statusText) {
                    var response: any = {};
                    response.data = JSON.parse(data);
                    response.status = status;
                    response.config = config;
                    response.statusText = statusText;
                    return response;
                }
            }
        });
    };


    ConfigurationResourceService.prototype.projectConfiguration = function (projectId: string) {
        return $resource('rest/configurations/:projectId/project', {
            projectId
        }, {
            list: { method: "GET", isArray: true },
            create: { method: "POST"},
            get: { method: "GET"},
            delete: { method: "DELETE"},
            update: { method: "PUT"}
        });
    };

    ConfigurationResourceService.prototype.trainTypesConfiguration = function (projectId: string, trainTypeId?: string, configId?: string) {
        return $resource('rest/configurations/:projectId/traintypes/:trainTypeId/:configId', {
            projectId,
            trainTypeId,
            configId
        }, {
            list: { method: "GET", isArray: true },
            create: { method: "POST"},
            get: { 
                method: "GET",
                transformResponse: function (data, header, status, config, statusText) {
                    var response: any = {};
                    response.data = JSON.parse(data);
                    response.status = status;
                    response.config = config;
                    response.statusText = statusText;
                    return response;
                }
            },
            delete: { method: "DELETE"},
            update: { method: "PUT"}
        });
    };

    ConfigurationResourceService.prototype.zabbixConfiguration = function () {
        return $resource('rest/config/noc/zabbix/:projectId');
    };

    ConfigurationResourceService.prototype.getBoxDiscriptorsForTrip = function (criteria, callback) {
        console.log(criteria)
        return $resource('rest/config/box/discriptors/:projectId/:tripId').get(criteria, callback, () => {
            $state.go('trip.search', {
                'projectId': criteria.projectId
            })
        });
    };

    ConfigurationResourceService.prototype.getBoxDiscriptors = function (criteria, callback) {
        return $resource('rest/mar3/box/discriptors').get(criteria, callback);
    };

    ConfigurationResourceService.prototype.getCoachDiscriptors = function (criteria, callback) {
        return $resource('rest/radioUserCount/period/discriptors').get(criteria, callback);
    };

    ConfigurationResourceService.prototype.getTripCoachDiscriptors = function (criteria, callback) {
        return $resource('rest/radioUserCount/trip/discriptors/:projectId/:tripId').get(criteria, callback);
    };

    ConfigurationResourceService.prototype.getObisDiscriptorsForTrip = function (criteria, callback) {
        return $resource('rest/obis/discriptors/trip/:projectId/:tripId/').get(criteria, callback);
    };

    ConfigurationResourceService.prototype.getObisDiscriptors = function (criteria, callback) {
        return $resource('rest/obis/discriptors/period').get(criteria, callback);
    };

    ConfigurationResourceService.prototype.getNmsVersion = function () {
        return $resource('rest/config/noc/version', {}, {
            get: {
                method: 'GET',
                isArray: false,
                transformResponse: function (data, header, status, config, statusText) {
                    var response: any = {};
                    var data = JSON.parse(JSON.stringify(data));
                    var version = Object.keys(data).reduce(function(acc, key) {
                        acc += data[key];
                        return acc;
                    }, '');
                    response.data = {
                        version: version.replace(/(^"|"$)/g, '')
                    };
                    response.status = status;
                    response.config = config;
                    response.statusText = statusText;
                    return response;
                }
            }
        });
    };

    return new ConfigurationResourceService();
}]);

services.factory('SecurityResourceService', ["$resource", function ($resource) {
    function SecurityResourceService() {
    }
    SecurityResourceService.prototype.allUserGroups = function () {
        return $resource('rest/security/all/usergroup');
    };
    return new SecurityResourceService();
}]);

services.factory('EventResource', ["$resource" , function ($resource) {
    function EventResource(){
    }
    EventResource.prototype.getTrainEvents = function () {
        return $resource('rest/trainEvents/:trainId');
    };
    return new EventResource();
}]);

services.factory('SimResource', ["$resource", "$http", function ($resource, $http) {
    function SimResource() {
    }

    SimResource.prototype.sims = function () {
        return $resource('rest/sim/');
    };

    SimResource.prototype.simsForTrain = function () {
        return $resource('rest/sim/train/:trainId');
    };

    SimResource.prototype.sim = function () {
        return $resource('rest/sim/:id', {id:'@id'},
        { 
            update: 
            {
               method: 'PUT'
            }
       });
    };

    SimResource.prototype.simWithIccid = function () {
        return $resource('rest/sim/:iccid');
    };

    SimResource.prototype.simUsage = function () {
        return $resource('rest/sims/usage/:iccid');
    };

    SimResource.prototype.simData = function () {
        return $resource('rest/sims/data/:iccid');
    };

    SimResource.prototype.simDataPeriod = function () {
        return $resource('rest/sims/data/period/:iccid');
    };

    SimResource.prototype.pools = function () {
        return $resource('rest/sims/pool');
    };

    SimResource.prototype.pool = function () {
        return $resource('rest/sims/pool/:id');
    };

    SimResource.prototype.poolUsage = function () {
        return $resource('rest/sims/pool/usage/:id');
    };

    SimResource.prototype.poolData = function () {
        return $resource('rest/sims/pool/data/:id');
    };

    SimResource.prototype.batchSimUsage = function (projectId, iccidList) {
        return $http.post('rest/sims/usage/list?projectId=' + projectId, {
            iccids: iccidList
        });
    };

    return new SimResource();
}]);

services.factory('TrainConfigurationResource', ["$resource", "$http", function ($resource,$http) {
    function TrainConfigurationResource() {
    }

    TrainConfigurationResource.prototype.trainConfig = function () {
        return $resource('rest/trainconfiguration/:trainId/:boxId');
    };

    TrainConfigurationResource.prototype.trainTree = function () {
        return $resource('rest/cmdb/traintree');
    };

    TrainConfigurationResource.prototype.trainItem = function () {
        return $resource('rest/cmdb/trainitem/:type/:key');
    };

    TrainConfigurationResource.prototype.trainItemHistory = function () {
        return $resource('rest/cmdb/trainitem/:type/:key/history');
    };

    TrainConfigurationResource.prototype.uploadBdas = function (fileFormData, projectId) {
        return $http.post('rest/cmdb/uploadBdaFile', fileFormData, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined},
            params: { projectId : projectId }
        });
    };

    return new TrainConfigurationResource();
}]);

services.factory('MonitoringResource', ["$resource", function ($resource) {
    function MonitoringResource() {
    }

    MonitoringResource.prototype.getInformation = function () {
        return $resource('rest/monitoring/context/:trainId');
    };
    MonitoringResource.prototype.getLinkInformation = function () {
        return $resource('rest/monitoring/links/:trainId');
    };

    MonitoringResource.prototype.getTableOverview = function () {
        return $resource('rest/monitoring/table');
    };

    MonitoringResource.prototype.getTrains = function () {
        return $resource('rest/monitoring/trains');
    };

    MonitoringResource.prototype.getAlarmEvents = function () {
        return $resource('rest/monitoring/alarmEvents/:trainId');
    };

    MonitoringResource.prototype.deleteAlarm = function (projectId, description, trainId, boxId) {
        return $resource('rest/monitoring/alarmEvents/:trainId', {trainId: trainId}, {
            delete: {
                method: 'DELETE',
                params: {projectId: projectId,description: description,boxId: boxId}
            }
        });
    };

    MonitoringResource.prototype.getTrainAlarms = function () {
        return $resource('rest/monitoring/alarms/:trainId');
    };


    return new MonitoringResource();
}]);


services.factory('TrainConsistResourceService', ["$resource", function ($resource) {
    function TrainConsistResourceService() {

    }

    TrainConsistResourceService.prototype.getLatestConsist = function () {
        return $resource('rest/config/consist/latest');
    };

    return new TrainConsistResourceService();
}]);


services.factory('OperatorResourceService', ["$resource", function ($resource) {
    function OperatorResourceService() {

    }

    OperatorResourceService.prototype.getListOperators = function () {
        return $resource('rest/operators');
    };

    return new OperatorResourceService();
}]);

export default services;
